/**
 * Palette da volantino A3 Munlight Sonata (PDF CIL-MunlightSonata-A3-AW).
 * Campionamento: fondo chiaro caldo ~#fffeee, colonna scura ~#444f5a, accenti viola ~#a060b0.
 */
export const MUNLIGHT = {
  bgLight: '#FFFEF2',
  textInk: '#323642',
  textMuted: '#5C6370',
  bgSlate: '#444F5A',
  bgSlateDeep: '#3A3F4A',
  white: '#FFFFFF',
  /** Accento orchidea / magenta smorzato (barre data, “Sonata”, titoli sezione) */
  accent: '#9E63AC',
  accentHover: '#B07EBC',
  accentSoft: '#C9A3D4',
  /** Barra data stile flyer */
  dateBar: '#9E63AC',
};

/** Prenotazione rassegna sul sito Munlab — eventi 2026, sezione Mun-Light sonata */
export const MUNLIGHT_BOOKING_URL =
  'https://www.munlabtorino.it/eventi-2026/#mun-light-sonata';
